
import React, { forwardRef } from 'react';

const InputWithIcon = forwardRef(({ label, id, icon, error, containerClassName = "mb-4", inputClassName = "", ...props }, ref) => (
    <div className={containerClassName}>
    {label && (
      <label
        className="mb-2 block text-sm font-bold text-slate-700"
        htmlFor={id}
      >
        {label}
      </label>
    )}
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        {icon}
      </div>
      <input
        id={id}
        ref={ref}   // ✅ now ref is passed correctly
        {...props}
        className={`w-full appearance-none rounded-xl border bg-white/90 py-3 px-4 pl-10 leading-tight text-slate-800 shadow-sm outline-none transition placeholder:text-slate-400 ${inputClassName} ${
          error ? 'border-red-400 focus:ring-red-500' : 'border-slate-200 focus:ring-emerald-500'
        }`}
      />
    </div>
    {error && <p className="mt-1 text-xs italic text-red-500">{error}</p>}
  </div>
));

InputWithIcon.displayName = 'InputWithIcon'; // helpful for React DevTools

export default InputWithIcon;



// import React from 'react';

// const InputWithIcon = ({ label, id, icon, error, ...props }) => (
//   <div className="mb-4">
//     <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={id}>
//       {label}
//     </label>
//     <div className="relative">
//       <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//         {icon}
//       </div>
//       <input
//         id={id}
//         ref={ref}   // ✅ now the parent can call .focus()
//         {...props}
//         className={`shadow-sm appearance-none border rounded-lg w-full py-3 px-4 pl-10 text-gray-700 leading-tight focus:outline-none focus:ring-2 ${
//           error ? 'border-red-500 focus:ring-red-500' : 'focus:ring-blue-500'
//         }`}
//       />
//     </div>
//     {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
//   </div>
// );

// export default InputWithIcon;
